export function isLongSentences(song) {
	let count = 0;
	if (song.parsed_lines) {
		for (let i = 0; i < song.parsed_lines.length; i++) {
			const line = song.parsed_lines[i];
			if (line.en)
				if (line.en.length > 40) {
					count++;
				}
		}
	}
	return count;
}
